export const getCandidateNames = candidateIds => {
  const candidates = Array.isArray(candidateIds)
    ? candidateIds
    : candidateIds
    ? [candidateIds]
    : []

  const names = candidates
    .map(candidate => {
      if (candidate && typeof candidate === "object") {
        return candidate.name || candidate.first_name || candidate.candidate_name || ""
      }
      return ""
    })
    .filter(Boolean)

  return names.length ? names.join(", ") : "-"
}

export const getCandidateIds = candidateIds => {
  const candidates = Array.isArray(candidateIds)
    ? candidateIds
    : candidateIds
    ? [candidateIds]
    : []

  return candidates
    .map(candidate => {
      if (candidate && typeof candidate === "object") {
        return candidate.id ?? candidate.candidate_id ?? candidate.value
      }
      return candidate
    })
    .filter(candidateId => candidateId !== undefined && candidateId !== null && candidateId !== "")
}
